$(function(){
    'use strict';

    let $modal_loader = '<div class="loader"><div class="loader-track"><span class="sanke"></span></div></div>';
    
    $('.page-loader').remove();

    const ss_fire = $('.ss-links .ss-fire')

    ss_fire.on("mouseover", function () {
        if ($(window).width() > 1025) {
            let $this = $(this),
            index = $this.index();
            $this.siblings().removeClass('active');
            $this.parent('.ss-links').siblings('.ss-container').removeClass().addClass('ss-container active'+(index+1)).find('.sub-sub-menu').removeClass('active').eq(index).addClass('active');
        }
    })

    ss_fire.on("mouseleave", function () {
        if ($(window).width() > 991) {
            let $this = $(this);
            $this.addClass('active');
        }
    })
    
    header();
    progressnav();
    counters();
    let lastScrollTop = 0;
    $(window).on("scroll", () => {
        header();
        progressnav();
        
        //detect down scroll
        let st = $(this).scrollTop();
        if (st > lastScrollTop) {
            //dowwwwwn
            counters();
            if(st > 350){
                $('.timer-progress').addClass('down');
            }
        } else {
             if(st < 450){
                $('.timer-progress').removeClass('down');
            }
        }
        lastScrollTop = st;
        /***********/
    })
    
    
    $('.search-open').on("click", () => {
        let $el = $('.search-page');
        $el.addClass('open');
        $el.find(".search-input").trigger("focus");
    })
    
    $('.search-close').on('click', () => {
        $('.search-page').removeClass('open').find("input").val("");
    })
    
    
    $(".fill-carousal").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 300,
      arrows: true,
      fade: true,
      rtl: document.documentElement.getAttribute("dir") === "rtl",
    })
    $(".slices-carousal").slick({
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 300,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".fill-carousal",
      rtl: document.documentElement.getAttribute("dir") === "rtl",
        
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
    
    $(".slices-carousal .slick-slide").on("mouseover", function () {
        if ($(window).width() > 1025) {
            $(".fill-carousal .slick-next").click();
            $(this).addClass("slick-current").siblings().removeClass("slick-current");
        }
    })
    
    $('body').on('keydown', (e) => {
        if (e.keyCode === 27) {
            $('.k-button').click();
        }
    })
    
    $('.close-nav').on("click", () => {
        $('.sm-container').addClass('close');
    })
    
    $('.li-services').on('mouseover', () => {
        if ($(window).width() > 1025) {
            $('.own-modal').attr('data-usage', 'nav').removeClass('hidden');
            $('.sm-container').removeClass('close');
        }
    }).on('mouseleave', () => {
        if ($(window).width() > 991) {
            $('.own-modal').attr('data-usage', '').addClass('hidden');
        }
        
    })
    
    $('.open-mobile-nav').on('click', function() {
        let parent = $('.nav-container'),
            child = $('.nav-wrapper');
        parent.addClass('active');
        child.addClass('active');
    })
    
    $('.cmn').on('click', () => {
        let parent = $('.nav-container'),
            child = $('.nav-wrapper');
        parent.removeClass('active');
        child.removeClass('active');
    })
    
    $('.nav-container>*').on('click', (e) => {
        e.stopPropagation();
    })
    
    $('.out-nav > ul > li > bdi').on('click', function() {
        $(this).siblings('.sm-container').addClass('d-block');
    })
    
    
    /*function loopy_slider() {
        $('.slider-wrapper .active').each(function () {
            let $this = $(this),
                $parent = $this.parent('.slider-wrapper');
            $this.addClass('hidden').removeClass('active');
            $this.next().removeClass('hidden').addClass('active');
            if ($parent.children().last().hasClass("active")) {
                setTimeout(function () {
                    $parent.children().first().removeClass("hidden").addClass("active");
                }, 3000);
            }
        });
    }

    let autoslider = setInterval(loopy_slider, 3000);*/
    
    //clearInterval(autoslider);
    //autoslider = setInterval(loopy_slider, 3000);
    
    
    
    $(".slider-button").on("click", function () {
        if ($(this).data("name") === "left") {
            leftSlide();
        } else {
            rightSlide();
        }
    });
    
    $(document).on('click','.goto-modal', function () {
        let snippet = $(this).data("name"),
            id = $(this).data("id"),
            action = $(this).data("action"),
            $ownmodal = $('.own-modal'),
            $wrapper = $ownmodal.children('#data-wrapper'),
            text = $(this).find('.fg-text').html(),
            feedback;
        $('body').addClass('overflow-hidden');
        $ownmodal.removeClass('hidden');
        
        $.ajax({
            url: "/ajax/snippets.php",
            type: "POST",
            data: {
                snippet: snippet,
                id: id,
                text: text,
                action: action
            },
            beforeSend: function () {
                $wrapper.html($modal_loader);
            },
            success: (response) => {
                feedback = JSON.parse(response);
                $wrapper.html(feedback.html);
            },
            complete: function () {

            }
        })
    });

    $(document).on('click', '.fg-confirm', function () {
        let $this = $(this),
            id = $this.data("id"),
            elementId = $this.attr("id"),
            action = $this.data("action"),
            feedback

        $.ajax({
            url: "/ajax/save.php",
            type: "POST",
            data: {
                id: id,
                act: action
            },
            beforeSend: function () {
                $this.removeAttr('id')
            },
            success: (response) => {
                feedback = JSON.parse(response)
            },
            complete: function () {

                feedback_system(feedback.type, feedback.message);
                if (feedback.type === 'error') {
                    $this.attr('id', elementId)
                } else {
                    $('.close-modal').trigger("click")
                    $('#trow-'+id).remove()
                }

            }
        })
    })
    
    
    $(document).on('click', '.close-modal', function () {
        var $ownmodal = $('.own-modal'),
            $wrapper = $ownmodal.children('#data-wrapper');
        $ownmodal.addClass("hidden");
        $wrapper.html("");
        $('body').removeClass('overflow-hidden');
    });
    
    $(document).on('click', '.close-modal *', function (e) {
        e.stopPropagation();
    });
    
    $('#menu-toggle').on('click', function () {
        $('.dashboard').toggleClass('toggled');
    });
    
    
    $('.blog-photo').on('change', handleFiles)
    
    $('#close-feedback>i').on('click', function () {
        $(this).parents('#ajax-feedback').addClass('fake-hidden');
    });
    
    
    $('.hbdaaaaaaaan').slick({
        arrows: false,
        dots: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 4,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
        ]
    });
    
    $('.hbdaaaaaaaan2').slick({
        arrows: false,
        dots: true,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 4,
        autoplay: true,
        autoplaySpeed: 2000,
        infinite: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              }
            }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
        ]
    });
    
    
    $('.collapse_btn').on('click', function () {
        $(this).children('i').toggleClass('hidden');
        $(this).parents('.main').siblings('.sub-menu').slideToggle(250);
    });
    
    $('.expand-mobile-menu').on('click', function () {
        $(this).siblings('.sm-container').slideToggle(250);
        $(this).children('i').toggleClass('hidden');
    });    
    
    $('.quick-service').on('click', function () {
        $('.quick-service').removeClass('active');
        $(this).toggleClass('active');
        let service = $(this).data('id');
        $('.to-hidden').addClass('hidden');
        $("[data-name="+service+"_n]").removeClass('hidden');
    });

    (function examTimer(){
        const timer = $("#time")
        const started = timer.data("stated-date")
        let countDownDate = new Date(started).getTime()
        let currentTime = new Date().getTime()
        let distance = countDownDate - currentTime;

        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
        let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString();

        if (hours.length < 2) hours = "0"+hours
        if (minutes.length < 2) minutes = "0"+minutes
        if (seconds.length < 2) seconds = "0"+seconds

        if(distance<0){
            $(document).find(".form-submitter").trigger("click")
            clearTimeout(examTimer);
        } else {
            timer.html(`${hours}:${minutes}:${seconds}`)
        }
        //timer.html(`${hours}:${minutes}:${seconds}`)
        setTimeout(function (){
            examTimer()
        }, 1000)
    })();

    $(document).on("click", ".clear-answer", function (e){
        e.preventDefault()
        const parentContainer = $(this).parent(".question-options")
        parentContainer.find("[type='radio']").prop("checked", false)
        $(this).addClass("d-none")
    })

    $(document).on("change", ".options", function (){
        const parentContainer = $(this).parent()
        parentContainer.siblings(".clear-answer").removeClass("d-none")
    })


    /*(function timer_progress() {
        let $el = $('.ani-circle'),
            $parent = $el.parents('.timer-progress'),
            $target = $parent.find('.time'),
            minutes = $parent.data('mins'),
            duration = (minutes * 60) + 's',
            seconds = minutes * 60;
            
            //seconds = (Math.floor(seconds)) % 60;
            
            $target.text("0"+mins+":"+seconds);
            
        
        
        
        $el.css('animation-duration', duration);
        
        
        
        setTimeout(timer_progress, 1000);
        
        
    })();*/
    
    $('.accordion-button').on('click', function () {
        $(this).parents('.accordion-item').toggleClass('active');
    })
})